module.exports = __webpack_public_path__ + "media/images/gimmicks/gimmick-bubble-8342ab289b60e6e3e4d32781b97b842b.svg";